module.exports = {
    "collapse": `Comprimi`,
    "expand": `Espandi`
};


//# sourceMappingURL=it-IT.main.js.map
